export default __webpack_public_path__ + "static/media/photo-80.a5d5c1aa.png";